/** "12,345 input, 678 output tokens" for the AI usage lines; null when not recorded. */
export function formatUsage(usage: { inputTokens: number; outputTokens: number } | null | undefined): string | null {
  if (!usage) return null;
  return `${usage.inputTokens.toLocaleString()} input, ${usage.outputTokens.toLocaleString()} output tokens`;
}
